export const translation = {
  // Navigation
  nav_home: 'Startseite',
  nav_spreadsheet: 'CSSBuy Spreadsheet',
  nav_guides: 'Leitfäden',
  nav_review: 'Bewertung',
  nav_shipping: 'Versand',
  nav_warehouse: 'Lager',
  nav_coupon: 'Gutschein',
  nav_legit: 'Seriös?',
  nav_categories: 'Kategorien',
  nav_contact: 'Kontakt',
  nav_about: 'Über uns',
  nav_buying_guide: 'Einkaufsführer',

  // Language Switcher
  lang_pt: 'Português',
  lang_de: 'Deutsch',
  lang_en: 'English',

  // Hero
  hero_title: 'CSSBuy Spreadsheet: Produkte, Angebote und Leitfäden an einem Ort',
  hero_subtitle: 'Erkunden Sie das CSSBuy Spreadsheet mit organisierten Ressourcen, Kaufanleitungen, beliebten Kategorien, QC-Informationen, Versandtipps und aktualisierten Inhalten, um Ihre Produktsuche mit mehr Vertrauen zu unterstützen.',
  hero_cta_primary: 'CSSBuy Spreadsheet erkunden',
  hero_cta_secondary: 'Einsteiger-Guide starten',
  hero_trust: 'Unabhängige Information • Praktische Guides • Organisierter Inhalt',

  // Trust Cards
  trust_spreadsheet_title: 'CSSBuy Spreadsheet',
  trust_spreadsheet_desc: 'Finden Sie organisierte CSSBuy Spreadsheet-Ressourcen nach Kategorie und Suchabsicht.',
  trust_guides_title: 'Praktische Leitfäden',
  trust_guides_desc: 'Lernen Sie über Produkte, QC, Lagerung, Versand und Recherche.',
  trust_safety_title: 'Sicherheit zuerst',
  trust_safety_desc: 'Verstehen Sie Kosten, externe Links, QC und wichtige Punkte vor dem Kauf.',

  // Spreadsheet Intro
  spreadsheet_intro_h2: 'Was ist das CSSBuy Spreadsheet?',
  spreadsheet_intro_text: 'Das CSSBuy Spreadsheet kann als Ausgangspunkt für die Produktsuche und zum Finden von Ressourcen im Zusammenhang mit dem Kaufprozess genutzt werden. Wir haben Leitfäden, Kategorien und nützliche Informationen zusammengestellt, um Ihre Recherche einfacher und übersichtlicher zu gestalten.',
  spreadsheet_intro_cta: 'Vollständigen CSSBuy Spreadsheet Guide ansehen',

  // Categories
  categories_h2: 'CSSBuy Spreadsheet nach Kategorie erkunden',
  categories_cta: 'Alle Kategorien ansehen',
  cat_shoes: 'Shoes',
  cat_hoodies: 'Hoodies/Sweaters',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jackets',
  cat_pants: 'Pants/Shorts',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Underwear/Underpants',
  cat_jersey: 'Jersey',
  cat_accessories: 'Accessories',
  cat_bags: 'Bags',
  cat_belts: 'Belts',
  cat_perfumes: 'Perfumes',
  cat_other: 'Other Stuff',
  categories_view_all: 'Alle ansehen',

  // How It Works
  how_h2: 'Wie man das CSSBuy Spreadsheet nutzt',
  how_step1: 'Wählen Sie eine Kategorie',
  how_step2: 'Produkte recherchieren',
  how_step3: 'Informationen und Links prüfen',
  how_step4: 'QC bei Verfügbarkeit konsultieren',
  how_step5: 'Kosten und Optionen vergleichen',
  how_step6: 'Aktuelle Bedingungen vor dem Kauf bestätigen',

  // Popular Guides
  guides_h2: 'Beliebteste CSSBuy Leitfäden',
  guides_cta: 'Alle Leitfäden ansehen',
  guide_review: 'CSSBuy Review',
  guide_shipping: 'CSSBuy Shipping Cost',
  guide_coupon: 'CSSBuy Coupon',
  guide_discount: 'CSSBuy Discount Code',
  guide_warehouse: 'CSSBuy Warehouse',
  guide_legit: 'Is CSSBuy Legit?',
  guide_qc: 'CSSBuy QC Guide',
  guide_beginner: 'CSSBuy Beginner Guide',

  // Pillar Articles
  pillar_h2: 'Grundlegende CSSBuy Artikel',
  pillar_subtitle: 'Ausführliche Leitfäden für Ihre Produktsuche',
  pillar_read: 'Artikel lesen',

  // Comparison
  comparison_h2: 'Vor dem Kauf vergleichen',
  comparison_factor: 'Faktor',
  comparison_check: 'Zu prüfen',
  comparison_product: 'Produkt',
  comparison_product_info: 'Aktuelle Informationen',
  comparison_price: 'Preis',
  comparison_price_info: 'Aktueller Wert',
  comparison_weight: 'Gewicht',
  comparison_weight_info: 'Geschätztes/echtes Gewicht',
  comparison_shipping: 'Versand',
  comparison_shipping_info: 'Ziel und Methode',
  comparison_qc: 'QC',
  comparison_qc_info: 'Verfügbare Fotos/Infos',
  comparison_link: 'Link',
  comparison_link_info: 'Funktionalität und Herkunft',
  comparison_policy: 'Richtlinie',
  comparison_policy_info: 'Aktuelle Regeln',

  // Safety
  safety_h2: 'Sicherheit und wichtige Informationen',
  safety_text: 'Diese Website ist eine unabhängige Ressource. Informationen über Produkte, Verkäufer, QC, Preise, Versand, Gutscheine und Verfügbarkeit können sich ändern. Überprüfen Sie immer die aktuellen Daten, bevor Sie eine Bestellung oder Zahlung vornehmen.',
  safety_cta: 'Sicherheitsleitfaden lesen',

  // FAQ
  faq_h2: 'Häufig gestellte Fragen',
  faq_q1: 'Was ist CSSBuy Spreadsheet?',
  faq_a1: 'Das CSSBuy Spreadsheet ist eine organisierte Ressource, die Produktkategorien, Leitfäden und Informationen für die Kaufrecherche zusammenfasst.',
  faq_q2: 'Wie verwendet man CSSBuy Spreadsheet?',
  faq_a2: 'Wählen Sie eine Kategorie, recherchieren Sie Produkte, prüfen Sie Links und Informationen, konsultieren Sie QC und vergleichen Sie Kosten vor dem Kauf.',
  faq_q3: 'Ist CSSBuy Spreadsheet kostenlos?',
  faq_a3: 'Ja, das CSSBuy Spreadsheet ist eine kostenlose Ressource für die Produktsuche.',
  faq_q4: 'Wie prüft man Links?',
  faq_a4: 'Überprüfen Sie immer, ob Links funktionieren und aus einer vertrauenswürdigen Quelle stammen, bevor Sie eine Zahlung vornehmen.',
  faq_q5: 'Was sind QC-Fotos?',
  faq_a5: 'QC-Fotos sind Qualitätskontrollbilder, die im Lager aufgenommen werden, um den tatsächlichen Zustand des Produkts vor dem Versand zu überprüfen.',
  faq_q6: 'Wie funktioniert der Versand?',
  faq_a6: 'Der Versand hängt vom Ziel, dem Paketgewicht, der gewählten Methode und den Zollvorschriften des Landes ab.',
  faq_q7: 'Wie viel kostet der Versand?',
  faq_a7: 'Die Versandkosten variieren je nach Gewicht, Ziel und Versandmethode. Weitere Details finden Sie in unserem Versandleitfaden.',
  faq_q8: 'Ist CSSBuy vertrauenswürdig?',
  faq_a8: 'Die Vertrauenswürdigkeit hängt von mehreren Faktoren ab. Überprüfen Sie immer aktuelle Informationen vor dem Kauf.',
  faq_q9: 'Ist CSSBuy seriös?',
  faq_a9: 'Weitere Informationen zur Seriosität finden Sie in unserem vollständigen Leitfaden.',
  faq_q10: 'Was sollte vor dem Kauf geprüft werden?',
  faq_a10: 'Überprüfen Sie Produktinformationen, Preise, Gewicht, Versandoptionen, QC-Fotos und aktuelle Richtlinien vor jedem Kauf.',

  // Final CTA
  final_cta_h2: 'Bereit, das CSSBuy Spreadsheet zu erkunden?',
  final_cta_text: 'Starten Sie mit den beliebtesten Ressourcen und finden Sie den richtigen Leitfaden für Ihre Recherche.',
  final_cta_primary: 'CSSBuy Spreadsheet erkunden',
  final_cta_secondary: 'Hauptwebsite besuchen',

  // Footer
  footer_resources: 'Ressourcen',
  footer_information: 'Information',
  footer_legal: 'Rechtliches',
  footer_languages: 'Sprachen',
  footer_spreadsheet: 'CSSBuy Spreadsheet',
  footer_guides: 'Leitfäden',
  footer_reviews: 'Bewertungen',
  footer_shipping: 'Versand',
  footer_qc: 'QC',
  footer_warehouse_footer: 'Lager',
  footer_safety_footer: 'Sicherheit',
  footer_faq: 'FAQ',
  footer_about: 'Über uns',
  footer_editorial: 'Editorial Policy',
  footer_methodology: 'Methodology',
  footer_contact_footer: 'Kontakt',
  footer_disclaimer: 'Disclaimer',
  footer_privacy: 'Datenschutz',
  footer_terms: 'Nutzungsbedingungen',
  footer_disclaimer_text: 'Diese Website ist eine unabhängige Ressource und repräsentiert nicht offiziell CSSBuy. Informationen können sich ändern. Überprüfen Sie immer vor dem Kauf.',

  // Buttons
  btn_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  btn_buy_it_now: 'Buy It Now',
  btn_read_more: 'Mehr lesen',
  btn_learn_more: 'Mehr erfahren',
  btn_visit_site: 'Hauptwebsite besuchen',
  btn_explore: 'Erkunden',

  // Article
  article_published: 'Veröffentlicht',
  article_updated: 'Aktualisiert',
  article_author: 'Autor',
  article_related: 'Verwandte Artikel',
  article_toc: 'Inhalt',
  article_quick_answer: 'Kurzantwort',
  article_introduction: 'Einleitung',
  article_step_by_step: 'Schritt für Schritt',
  article_comparison: 'Vergleich',
  article_mistakes: 'Häufige Fehler',
  article_safety: 'Sicherheit',
  article_cta: 'Weiter erkunden',

  // Breadcrumb
  breadcrumb_home: 'Startseite',
  breadcrumb_spreadsheet: 'CSSBuy Spreadsheet',

  // Meta
  meta_title: 'CSSBuy Spreadsheet: Guides, Kategorien und Ressourcen | CSSBuyBR',
  meta_description: 'Erkunden Sie das CSSBuy Spreadsheet mit Kaufanleitungen, Produktkategorien, Versandtipps und QC-Informationen. Unabhängige Ressource für Produktsuche.',
  meta_keywords: 'cssbuy spreadsheet, cssbuy guide, cssbuy kategorien, cssbuy versand, cssbuy review',

  // Dropdown
  dropdown_all_categories: 'Alle Kategorien',
  dropdown_select: 'Kategorie wählen',

  // Safety Notice
  safety_notice: 'Diese Website ist eine unabhängige Ressource und repräsentiert nicht offiziell CSSBuy. Informationen über Preise, Produkte, Verkäufer, QC, Versand, Gutscheine und Verfügbarkeit können sich ändern. Überprüfen Sie immer die aktuellen Daten vor einer Bestellung oder Zahlung.',
};

export default translation;